/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import "./sidebar.css";
import { NavLink, useNavigate } from "react-router-dom";
import busIcon from "../../../assets/images/buss.svg";
import transIcon from "../../../assets/images/transit-Icon.svg";
import lookDown from "../../../assets/images/lookDown.svg";
import lookUp from "../../../assets/images/lookUp.svg";
import compareData from "../../../assets/images/compareData.svg";
import setting from "../../../assets/images/settings.svg";
import chargerIcon from "../../../assets/images/chargerLogo.svg";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

import { connect, useSelector } from "react-redux";

const Sidebar = () => {
  const navigate = useNavigate();
  const currentUrl = window?.location?.pathname;
  const { currentUser } = useSelector((state) => state.user);
  const [expand, setExpand] = useState(true);

  const [lookDownLogo] = useState(lookDown);

  const menuItems = [
    {
      name: "Dashboard",
      icon: "pi-home",
      link: "/",
      roles: ["admin", "agency", "sub"],
    },
    {
      name: "Agency",
      icon: "pi-building",
      link: "/agency",
      roles: ["admin"],
    },

    {
      name: "Chargers",
      icon: chargerIcon,
      iconType: "img",
      link: "/chargers",
      roles: ["admin", "agency", "sub"],
    },
    {
      name: "Buses",
      icon: busIcon,
      iconType: "img",
      link: "/buses",
      roles: ["admin", "agency", "sub"],
    },
    {
      name: "Search Transit Agency data",
      icon: transIcon,
      iconType: "img",
      link: ["/busdata", "/chargerdata"],
      roles: ["admin", "agency", "sub"],
      type: "parent",
      children: [
        {
          name: "Bus Data",
          icon: "pi-home",
          link: "/busdata",
          roles: ["admin", "agency", "sub"],
        },
        {
          name: "Charger Data",
          icon: "pi-home",
          link: "/chargerdata",
          roles: ["admin", "agency", "sub"],
        },
      ],
    },
    {
      name: "Compare Data",
      icon: compareData,
      iconType: "img",
      link: ["/comparebuses", "/comparechargers"],
      roles: ["admin", "agency", "sub"],
      type: "parent",
      children: [
        {
          name: "Compare Buses",
          icon: "pi-home",
          link: "/comparebuses",
          roles: ["admin", "agency", "sub"],
        },
        {
          name: "Compare Chargers",
          icon: "pi-home",
          link: "/comparechargers",
          roles: ["admin", "agency", "sub"],
        },
      ],
    },
    {
      name: "Manage Users",
      link: "/manage-agencies",
      icon: "pi-users",
      roles: ["agency"],
    },
    {
      name: "Settings",
      link: "/settings",
      icon: setting,
      iconType: "img",
      roles: ["admin", "agency", "sub"],
    },
  ];

  const handleNavigate = (link) => {
    navigate(link);
  };

  return (
    <div className="layout-sidebar">
      <ul className="layout-menu" style={{ padding: "15px 0 0 0" }}>
        {menuItems?.map(
          (element, index) =>
            element?.roles?.includes(currentUser?.role) && (
              <>
                {((element?.link === "/manage-agencies" &&
                  currentUser?.role === "agency") ||
                  (element?.link === "/settings" &&
                    currentUser?.role === "sub")) && <hr />}
                <li
                  key={index}
                  onClick={() => {
                    if (
                      element?.type === "parent" &&
                      element?.link?.includes(currentUrl)
                    ) {
                      setExpand(!expand);
                    } else {
                      setExpand(true);
                    }

                    handleNavigate(
                      element?.type === "parent"
                        ? element?.link[0]
                        : element?.link
                    );
                  }}
                >
                  <NavLink
                    className={
                      (
                        element?.type === "parent"
                          ? element?.link?.includes(currentUrl)
                          : currentUrl === element?.link
                      )
                        ? "p-ripple active-route"
                        : "p-ripple"
                    }
                  >
                    {element?.iconType === "img" ? (
                      <i className="layout-menuitem-icon pi pi-fw">
                        <img
                          src={element.icon}
                          alt=""
                          className={
                            (
                              element?.type === "parent"
                                ? element?.link?.includes(currentUrl)
                                : currentUrl === element?.link
                            )
                              ? "filter"
                              : ""
                          }
                        />
                      </i>
                    ) : (
                      <i
                        className={`layout-menuitem-icon pi pi-fw ${
                          element.icon
                        } ${element.icon === "pi-users" ? "xx-pi-users" : ""}`}
                      />
                    )}

                    <span
                      className="layout-menuitem-text"
                      style={{ marginLeft: "8px" }}
                    >
                      {element.name}
                    </span>
                    {element?.type === "parent" && (
                      <img
                        src={
                          expand && element?.link?.includes(currentUrl)
                            ? lookUp
                            : lookDownLogo
                        }
                        style={{ marginLeft: "10px" }}
                      />
                    )}
                  </NavLink>
                </li>

                {expand &&
                  element?.children?.length > 0 &&
                  element?.link?.includes(currentUrl) &&
                  element?.children?.map((childElement, childindex) => (
                    <li onClick={() => handleNavigate(childElement?.link)}>
                      <NavLink
                        className={
                          childElement?.link === currentUrl
                            ? "p-ripple active-route"
                            : "p-ripple"
                        }
                      >
                        <span
                          className="layout-menuitem-text"
                          style={{ marginLeft: "8px" }}
                        >
                          {childElement?.name}
                        </span>
                      </NavLink>
                    </li>
                  ))}
              </>
            )
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
